import router from '../router'
import axios from 'axios'

// const apiURL = 'http://devapi.pinostory.com/api/' //version3 개발
const apiPythonURL = 'http://121.140.160.10:9502/' //version3 개발
const apiURL = 'http://api.pinostory.com/api/' //version3 실서버
const imgURL = "http://safetybellnewapi.dgmonglab.com";

const Unauthorized = 401;
const onUnauthorized = () => {
  router.push({path: "/auth", query: {logout: true}});
};

export const setAuthInHeader = token => {
  axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
};

export const request = {
  get(path, params=null) {
    return axios.get(`${apiURL + path}`, {params: params})
      .catch(({response}) => {
        const {status} = response;
        if (status === Unauthorized) return onUnauthorized();
        throw Error(response)
      })
  },
  post(path, data) {
    return axios.post(`${apiURL + path}`, data)
      .catch(({response}) => {
        const {status} = response;
        if (status === Unauthorized) return onUnauthorized();
        throw Error(response)
      })
  }
};

export const requestPython = {
  get(path, params=null) {
    return axios.get(`${apiPythonURL + path}`, {params: params})
      .catch(({response}) => {
        const {status} = response;
        if (status === Unauthorized) return onUnauthorized();
        throw Error(response)
      })
  },
  post(path, data) {
    return axios.post(`${apiPythonURL + path}`, data)
      .catch(({response}) => {
        const {status} = response;
        if (status === Unauthorized) return onUnauthorized();
        throw Error(response)
      })
  }
};